import { beAsyncTaskGetTaskDetails } from 'Api/beAsyncTaskApi'
import {
  beAutomationGetSentEmailItemDetail,
  beAutomationGetSentSMSItemDetail,
} from 'Api/beAutomationApi'
import { beEmailMessageApiGetMessageLazyDetails } from 'Api/beEmailMessageApi'
import {
  ACTIVITY_EVENT_TYPE_SENDINGS,
  beRecipientGetEmailActivity,
  beRecipientGetSmsActivity,
} from 'Api/beRecipientApi'
import { beMessGetSmsMessageByIdMessage } from 'Api/beSmsMessageApi'
import { CHANNEL_EMAIL, CHANNEL_SMS } from 'Constants/index'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import getIntl from 'Helpers/intl'

export const getActivity = (
  idRecipient,
  channel,
  pageNumber,
  pageSize,
  activityEventTypes,
) => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const params = {
    pageNumber,
    pageSize,
    orderDescending: true,
  }
  const data = {
    activityEventTypes,
  }
  const api =
    channel.toLowerCase() === CHANNEL_EMAIL
      ? beRecipientGetEmailActivity
      : beRecipientGetSmsActivity

  return Array.isArray(activityEventTypes) && activityEventTypes.length > 0
    ? api(idList, idRecipient, params, data)
    : Promise.resolve({
        IdTask: 0,
        Events: {
          TotalItems: 0,
          Items: [],
        },
      })
}

export const getTaskDetails = beAsyncTaskGetTaskDetails

export const fetchMessagesDetails = async (idMsgs, channel) => {
  const intl = getIntl()
  //
  const initialMsgDetails =
    channel === CHANNEL_SMS
      ? {
          0: {
            Subject: intl.formatMessage({
              id: 'Load.ActiveRecipientSummary.DescrWelcomeMsg',
            }),
          },
        }
      : {}

  //
  const api =
    channel === CHANNEL_EMAIL
      ? beEmailMessageApiGetMessageLazyDetails
      : beMessGetSmsMessageByIdMessage
  const msgDetails = await Promise.all(idMsgs.map((idMsg) => api(idMsg)))
  return msgDetails.reduce(
    (acc, details) => ({
      ...acc,
      ...(details ? { [details.Id]: details } : {}),
    }),
    initialMsgDetails,
  )
}

export const fetchSendingsDetails = async (idSendings, channel) => {
  const api =
    channel === CHANNEL_EMAIL
      ? beAutomationGetSentEmailItemDetail
      : beAutomationGetSentSMSItemDetail
  const sendingsDetails = await Promise.all(
    idSendings.map((idSending) => api(idSending)),
  )

  return sendingsDetails.reduce(
    (acc, { TriggerSentItemDetail }, index) => ({
      ...acc,
      ...(TriggerSentItemDetail
        ? { [idSendings[index]]: TriggerSentItemDetail }
        : {}),
    }),
    {},
  )
}

export const fetchItemsDetails = async (items, channel) => {
  const idMsgs = Array.from(
    new Set(
      items
        .filter(({ IdMessage }) => !!IdMessage)
        .map(({ IdMessage }) => IdMessage),
    ),
  )
  const idSendings = Array.from(
    new Set(
      items
        .filter(
          ({ IdSending, ActivityType }) =>
            !!IdSending && ActivityType === ACTIVITY_EVENT_TYPE_SENDINGS,
        )
        .map(({ IdSending }) => IdSending),
    ),
  )
  const msgDetails = await fetchMessagesDetails(idMsgs, channel)
  const sendingsDetails = await fetchSendingsDetails(idSendings, channel)

  return items.map((o) => ({
    ...o,
    message: msgDetails[o.IdMessage] || {},
    sending: sendingsDetails[o.IdSending] || {},
  }))
}
